import { createUseQuery } from 'api/common/createUseQuery'
import { fetchSkills, Skill } from 'api/fetchers/fetchSkills'
import { ApiQueryKeys } from 'constants/apiQueryKeys'

export const useSkills = createUseQuery({
  queryKey: ApiQueryKeys.SKILLS,
  fetcher: fetchSkills,
  selector: res => (res?.data as Skill[] | undefined) ?? ([] as Skill[]),
})
